import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Search from 'Components/Search'
import User from 'EurestoClass/User'
import Utils from 'EurestoFonction/Utils'
import React from 'react'



const DatagridContact = props => {
  return <Search limit={20} unsave defaultSearch={props.defaultSearch} path={'crm'} requete={'insee'}
                 search={props.search || 'insee_' + (props.name || '') + User.Entite.get().id}>
    <SearchClient/>
  </Search>

}

class SearchClient extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      search: props.search,
      key: Utils.getRandomNumber(),
    }
  }

  search = async (data, name) => {
    const search = this.state.search
    search[name] = data
    this.setState({
      search: search,
    }, () => this.props.searching && this.props.searching(search, { all: true }))
  }

  render () {
    return (
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 5, overflow: 'visible' }}
            justify={'flex-start'}
            alignContent={'flex-start'}>
        <Input
          onChange={this.search}
          name="?nom"
          value={this.state.search['?nom']}
          title={EurestoI18n.t('crm:Nom')}
        />
        <Input
          onChange={this.search}
          name="?cp"
          value={this.state.search['?cp']}
          title={EurestoI18n.t('crm:Code Postal')}
        />
        <Input
          onChange={this.search}
          name="?siret"
          value={this.state.search['?siret']}
          title={EurestoI18n.t('crm:siret')}
        />
      </Grid>
    )
  }

}

export default DatagridContact



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Search/insee.js